// skipcq: JS-W1028
import { useCallback, useContext, useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import BrewhousePageShell from '../../components/brewhouse/BrewhousePageShell';
import ReviewDetailsWorkspace from '../../components/reviewDetails/ReviewDetailsWorkspace';
import { TAB_NEW_REVIEWS } from '../../components/reviewDetails/ReviewDetailsTabs';
import { ReviewDetailsSeenProvider } from '../../context/ReviewDetailsSeenContext';
import { BrewerySessionContext } from '../../context/BrewerySessionContext';
import { trackReviewDetailsClaimRequired } from '../../utils/brewhousePortalAnalytics';

function ReviewDetailsPageContent() {
  const session = useContext(BrewerySessionContext);
  const [activeTab, setActiveTab] = useState(TAB_NEW_REVIEWS);
  const [selectedItemKey, setSelectedItemKey] = useState(null);

  const handleTabChange = useCallback((nextTab) => {
    setActiveTab(nextTab);
  }, []);

  const handleSelectItemKey = useCallback((nextItemKey) => {
    setSelectedItemKey(nextItemKey);
  }, []);

  useEffect(() => {
    if (!session.isLoading && session.breweryId === null) {
      trackReviewDetailsClaimRequired();
    }
  }, [session.breweryId, session.isLoading]);

  if (session.isLoading) {
    return (
      <Box sx={{ py: 8, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress color="primary" />
      </Box>
    );
  }

  if (session.breweryId === null) {
    return (
      <BrewhousePageShell
        breadcrumbs={[{ label: 'Review Details' }]}
        title="Review Details"
        maxWidth={1200}
      >
        <Card variant="outlined">
          <CardContent>
            <Typography variant="body1" color="text.secondary">
              Complete your brewery claim to view review details. Use Claim in the left
              navigation to get started.
            </Typography>
          </CardContent>
        </Card>
      </BrewhousePageShell>
    );
  }

  return (
    <BrewhousePageShell
      breadcrumbs={[{ label: 'Review Details' }]}
      title="Review Details"
      maxWidth={1200}
    >
      <ReviewDetailsSeenProvider breweryId={session.breweryId} activeTab={activeTab}>
        <ReviewDetailsWorkspace
          breweryId={session.breweryId}
          breweryName={session.activeBreweryName}
          activeTab={activeTab}
          onTabChange={handleTabChange}
          selectedItemKey={selectedItemKey}
          onSelectItemKey={handleSelectItemKey}
        />
      </ReviewDetailsSeenProvider>
    </BrewhousePageShell>
  );
}

export default function ReviewDetailsPage() {
  return <ReviewDetailsPageContent />;
}
